import React from "react";

interface UserRowProps {
  header?: string;
  subtitle?: string;
  children?: React.ReactNode;
  preSection?: React.ReactNode;
  className?: string;
}

export const UserRow: React.FC<UserRowProps> = ({
  header,
  subtitle,
  children,
  className,
  preSection,
}) => {
  return (
    <div className="grid gap-6 p-4 grid-rows-min-con-2">
      {header?.length > 0 && (
        <h1 className="font-bold border-b-2 border-gray-200 pb-2">{header}</h1>
      )}
      {preSection && preSection}
      {subtitle?.length > 0 && <h2 className="text-md">{subtitle}</h2>}
      <div
        className={`grid ${
          className ? className : "md:grid-cols-3"
        } sm:grid-cols-1 gap-5 items-center`}
      >
        {children}
      </div>
    </div>
  );
};
